export const BOOTHS = 'booths';

export const BOOTH_KINDS = {
  MALCHUT: 'malchut',
  MAPAL: 'mapal',
  LIFE: 'Life',
};